import { createContext } from 'react'

export const ColorModeContext = createContext({
    //yes this should look like this
    toggleColorMode: () => {},
})
